import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import styled from 'styled-components';

const Section = styled.section`
  padding: 40px 0;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
`;

const SectionTitle = styled.h2`
  font-size: 28px;
  color: #333;
  text-align: center;
  margin-bottom: 30px;
`;

const CategoryItem = styled.div`
  padding: 10px;
  background-color: white;
  border-radius: 8px;
  text-align: center;
`;

const CategoryImage = styled.div`
  width: 50px;
  height: 50px;
  margin: 0 auto 10px;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const CategoryInfo = styled.div`
  h3 {
    font-size: 16px;
    color: #333;
    margin-bottom: 5px;
  }
  a {
    font-size: 14px;
    color: #007BFF;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;

const CategorySection = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    console.log('Fetching categories...');
    fetch('/api/categories/')
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        console.log('Categories fetched:', data);
        setCategories(data);
      })
      .catch((error) => console.error('Error fetching categories:', error));
  }, []);

  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    autoplay: true, // Enable auto-slide
    autoplaySpeed: 2000, // Adjust speed for auto-slide (milliseconds)
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <Section>
      <Container>
        <SectionTitle>Categories</SectionTitle>
        {categories && categories.length > 0 ? (
          <Slider {...settings}>
            {categories.map((category) => (
              <CategoryItem key={category.id}>
                <CategoryImage>
                  <img src={category.icon} alt={category.name} />
                </CategoryImage>
                <CategoryInfo>
                  <h3>{category.name}</h3>
                  <a href={`/categories/${category.slug}`}>Show All »</a>
                </CategoryInfo>
              </CategoryItem>
            ))}
          </Slider>
        ) : (
          <p>No categories found.</p>
        )}
      </Container>
    </Section>
  );
};

export default CategorySection;